import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = []

routes.push({
  path: '/',
  name: '首页',
  redirect: '/home'
})

const routesList = [
  'home',
  'article/:parent_id/:id',
  'drugInfo',
  'chargeMode'
  // 'pharmacopoeia/:parent_id/:id',
  // 'aboutUs/:parent_id/:id',
  // 'news/:parent_id/:id'
]

routesList.map(item => {
  routes.push({
    path: `/${item}`,
    name: item.split('/')[0],
    component: resolve => require([`@/view/${item.split('/')[0]}`], resolve)
  })
})

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

export default new Router({
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js